// 登录
import service from '@/utils/request'

export function login (data) {
  return service({
    url: '/service/admin/login',
    method: 'post',
    params: data
  })
}
// 后台资料修改
export function xinxixiugai (data) {
  return service({
    url: '/service/admin/admin_modify',
    method: 'post',
    params: data
  })
}
// 后台账号退出
export function adminLogout (data) {
  return service({
    url: '/service/admin/admin_logout',
    method: 'post',
    params: data
  })
}
// adminInfo
export function adminInfo (data) {
  return service({
    url: '/service/admin/admin_info',
    method: 'post',
    params: data
  })
}
// 添加轮播图
export function addSwiper (data) {
  return service({
    url: '/service/admin/add_swiper',
    method: 'post',
    params: data
  })
}
// 轮播图列表
export function swiperList (data) {
  return service({
    url: '/service/admin/swiper_list',
    method: 'post',
    params: data
  })
}
// 删除轮播图
export function swiperDelete (data) {
  return service({
    url: '/service/admin/swiper_delete',
    method: 'post',
    params: data
  })
}
// 删除轮播图
export function editSwiper (data) {
  return service({
    url: '/service/admin/edit_swiper',
    method: 'post',
    params: data
  })
}
// 删除轮播图
export function swiperSetstatus (data) {
  return service({
    url: '/service/admin/swiper_setstatus',
    method: 'post',
    params: data
  })
}
// 首页
export function shouyeshuju (data) {
  return service({
    url: '/service/admin/index',
    method: 'post',
    params: data
  })
}
